export type NextcloudEntry = {
  name: string
  path: string
  kind: 'file' | 'folder'
  fileId?: string | null
  mime?: string | null
  size?: string | null
  modified?: string | null
  encrypted?: boolean
}

export function nextcloudWebUrl(
  instanceUrl: string | null | undefined,
  fileId: string | null | undefined,
): string | null {
  if (!instanceUrl || !fileId) return null
  return `${instanceUrl.replace(/\/+$/, '')}/f/${fileId}`
}

export function isNextcloudText(entry: Pick<NextcloudEntry, 'name' | 'mime'>): boolean {
  if (/\.(md|markdown|txt|json|xml|csv)$/i.test(entry.name)) return true
  const mime = entry.mime || ''
  return /^text\//i.test(mime) || /markdown|json|xml/i.test(mime)
}

export function nextcloudBinaryNote(entry: Pick<NextcloudEntry, 'name' | 'mime'>): string {
  const mime = entry.mime || ''
  const name = entry.name.toLowerCase()
  if (mime === 'application/pdf' || name.endsWith('.pdf')) {
    return 'PDF stays in Nextcloud. Link it here, or open it there. Text import is for markdown and plain text.'
  }
  if (mime.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(name)) {
    return 'Image stays in Nextcloud. Open it there to view the original.'
  }
  if (/word|officedocument|opendocument|excel|powerpoint|spreadsheet/i.test(mime)) {
    return 'Office files stay in Nextcloud. Open them there. Text import is for markdown and plain text.'
  }
  return 'This file stays in Nextcloud.'
}

export function formatNextcloudModified(value: string | null | undefined): string {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatNextcloudSize(value: string | null | undefined): string {
  const bytes = Number(value)
  if (!value || !Number.isFinite(bytes) || bytes < 0) return ''
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) {
    const kb = bytes / 1024
    return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
